"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var attach_script_1 = tslib_1.__importDefault(require("../../../common/utils/attach-script"));
var safe_area_insets_1 = tslib_1.__importDefault(require("safe-area-insets"));
var styles_scss_1 = tslib_1.__importDefault(require("./styles.scss"));
var scriptApiUrl = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2';
var apiPromise = null;
var FacebookExternal = /** @class */ (function (_super) {
    tslib_1.__extends(FacebookExternal, _super);
    function FacebookExternal(props) {
        var _this = _super.call(this, props) || this;
        _this.saveContainerRef = function (ref) { return (_this.containerRef = ref); };
        _this.saveStretchedContainer = function (ref) { return (_this.stretchedContainerRef = ref); };
        _this.init = function () {
            window.FB.init({
                xfbml: true,
                version: 'v3.2',
            });
        };
        _this.handleFacebookReady = function (message) {
            if (message.type === 'video' && message.id === _this.getPlayerId()) {
                _this.onReady(message.instance);
            }
        };
        _this.setAllowAttribute = function () {
            if (!_this.containerRef) {
                return;
            }
            var iframe = _this.containerRef.querySelector('iframe');
            if (!iframe) {
                return;
            }
            if (!iframe.allow.includes('autoplay')) {
                iframe.setAttribute('allow', 'autoplay');
                iframe.setAttribute('src', iframe.src);
            }
        };
        _this.onReady = function (player) {
            var _a = _this.props, mobileMode = _a.mobileMode, fillAllSpace = _a.fillAllSpace, onIframeRef = _a.onIframeRef;
            _this.player = player;
            _this.iframeRef = _this.containerRef.querySelector('iframe');
            if (mobileMode || fillAllSpace) {
                _this.fitPlayer();
            }
            if (mobileMode) {
                safe_area_insets_1.default.onChange(_this.fitPlayer);
            }
            onIframeRef(_this.iframeRef);
            _this.attachEventsToPlayer();
            _this.setState({ isReady: true });
            _this.setSettings(_this.props);
            _this.updateFocusAbility();
        };
        _this.fitPlayer = function (insets) {
            var iframe = _this.iframeRef;
            if (iframe) {
                var stretchedContainerRect = _this.stretchedContainerRef.getBoundingClientRect();
                var rect = _this.iframeRef.getBoundingClientRect();
                var fillAllSpace = _this.props.fillAllSpace;
                var _a = fillAllSpace
                    ? stretchedContainerRect
                    : _this.props, height = _a.height, width = _a.width;
                var scale = 1;
                if (rect.height) {
                    if (!_this.videoSize) {
                        _this.videoSize = {
                            height: rect.height,
                            width: rect.width,
                        };
                    }
                    if (insets) {
                        var _b = insets.left, left = _b === void 0 ? 0 : _b, _c = insets.right, right = _c === void 0 ? 0 : _c;
                        var videoTagWidth = _this.videoSize.width - left - right;
                        scale = width / videoTagWidth;
                    }
                    scale *= height / _this.videoSize.height;
                    iframe.style.transformOrigin = 'top center';
                    iframe.style.transform = "scale(".concat(scale, ")");
                }
            }
        };
        _this.player = null;
        _this.containerRef = null;
        _this.iframeRef = null;
        _this.stretchedContainerRef = null;
        _this.videoSize = null;
        _this.state = {
            isReady: false,
        };
        return _this;
    }
    FacebookExternal.prototype.componentDidMount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!apiPromise) {
                            apiPromise = new Promise(function (resolve) { return (window.fbAsyncInit = resolve); });
                            (0, attach_script_1.default)(scriptApiUrl);
                        }
                        return [4 /*yield*/, apiPromise];
                    case 1:
                        _a.sent();
                        if (this.containerRef) {
                            window.FB.Event.subscribe('xfbml.ready', this.handleFacebookReady);
                            window.FB.Event.subscribe('iframeplugin:create', this.setAllowAttribute);
                            this.init();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FacebookExternal.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.src === this.props.src) {
            this.setSettings(nextProps, this.props);
        }
        else {
            this.setState({ isReady: false });
        }
    };
    FacebookExternal.prototype.componentDidUpdate = function (prevProps) {
        if (this.isPropsChanged(prevProps, ['src', 'width', 'height'])) {
            this.init();
        }
        if (this.isPropsChanged(prevProps, [
            'isVideoPauseRequested',
            'isVideoPlayRequested',
        ])) {
            this.updateFocusAbility();
        }
    };
    FacebookExternal.prototype.componentWillUnmount = function () {
        if (window.FB) {
            window.FB.Event.unsubscribe('xfbml.ready', this.handleFacebookReady);
            window.FB.Event.unsubscribe('iframeplugin:create', this.setAllowAttribute);
        }
        if (this.player) {
            this.detachEventsFromPlayer();
        }
    };
    FacebookExternal.prototype.isPropsChanged = function (prevProps, propNames) {
        var prev = lodash_1.default.pick(prevProps, propNames);
        var current = lodash_1.default.pick(this.props, propNames);
        return !lodash_1.default.isEqual(prev, current);
    };
    FacebookExternal.prototype.updateFocusAbility = function () {
        if (!this.iframeRef) {
            return;
        }
        var _a = this.props, isVideoPauseRequested = _a.isVideoPauseRequested, isVideoPlayRequested = _a.isVideoPlayRequested, isVideoPlaying = _a.isVideoPlaying, isVideoPaused = _a.isVideoPaused;
        var tabIndex = isVideoPauseRequested ||
            isVideoPlayRequested ||
            isVideoPlaying ||
            isVideoPaused
            ? 0
            : -1;
        this.iframeRef.setAttribute('tabindex', tabIndex);
    };
    FacebookExternal.prototype.getPlayerId = function () {
        return "".concat(this.props.src, "-").concat(this.props.compId);
    };
    FacebookExternal.prototype.attachEventsToPlayer = function () {
        var _a = this.props, onPlay = _a.onPlay, onPause = _a.onPause, onEnd = _a.onEnd;
        this._eventHanlers = {};
        this._eventHanlers.onPlay = this.player.subscribe('startedPlaying', onPlay);
        this._eventHanlers.onPause = this.player.subscribe('paused', onPause);
        this._eventHanlers.onEnd = this.player.subscribe('finishedPlaying', onEnd);
    };
    FacebookExternal.prototype.detachEventsFromPlayer = function () {
        this._eventHanlers.onPlay.release();
        this._eventHanlers.onPause.release();
        this._eventHanlers.onEnd.release();
        this._eventHanlers = {};
    };
    FacebookExternal.prototype.setSettings = function (_a, prevProps) {
        var isVideoPlayRequested = _a.isVideoPlayRequested, isVideoPauseRequested = _a.isVideoPauseRequested, muted = _a.muted;
        if (prevProps === void 0) { prevProps = {}; }
        if (!this.player || !this.state.isReady) {
            return null;
        }
        if (prevProps.isVideoPlayRequested !== isVideoPlayRequested &&
            isVideoPlayRequested) {
            this.togglePaused(false);
        }
        if (prevProps.isVideoPauseRequested !== isVideoPauseRequested &&
            isVideoPauseRequested) {
            this.togglePaused(true);
        }
        if (prevProps.muted !== muted) {
            this.toggleMute(muted);
        }
    };
    FacebookExternal.prototype.togglePaused = function (paused) {
        if (paused) {
            this.player.pause();
        }
        else {
            this.player.play();
        }
    };
    FacebookExternal.prototype.toggleMute = function (muted) {
        if (muted) {
            this.player.mute();
        }
        else {
            this.player.unmute();
        }
    };
    FacebookExternal.prototype.render = function () {
        var _a = this.props, src = _a.src, className = _a.className, fillAllSpace = _a.fillAllSpace;
        var _b = this.props, width = _b.width, height = _b.height;
        var props = {
            id: this.getPlayerId(),
            className: (0, classnames_1.default)('fb-video', styles_scss_1.default.iframe, className),
            ref: this.saveContainerRef,
            'data-href': src,
            'data-allowfullscreen': 'true',
        };
        if (!fillAllSpace) {
            props['data-width'] = Math.ceil(width);
            props['data-height'] = Math.ceil(height);
        }
        return (react_1.default.createElement("div", { ref: this.saveStretchedContainer, className: styles_scss_1.default.absolute },
            react_1.default.createElement("div", tslib_1.__assign({}, props))));
    };
    FacebookExternal.propTypes = {
        src: prop_types_1.default.string.isRequired,
        onPlay: prop_types_1.default.func,
        onPause: prop_types_1.default.func,
        onEnd: prop_types_1.default.func,
        onIframeRef: prop_types_1.default.func.isRequired,
        width: prop_types_1.default.number,
        height: prop_types_1.default.number,
        className: prop_types_1.default.string,
        compId: prop_types_1.default.string,
        simple: prop_types_1.default.bool,
        mobileMode: prop_types_1.default.bool,
        isVideoPlayRequested: prop_types_1.default.bool,
        isVideoPauseRequested: prop_types_1.default.bool,
        isVideoPlaying: prop_types_1.default.bool,
        isVideoPaused: prop_types_1.default.bool,
        fillAllSpace: prop_types_1.default.bool,
        loop: prop_types_1.default.bool,
        muted: prop_types_1.default.bool,
    };
    FacebookExternal.defaultProps = {
        compId: 'comp',
    };
    return FacebookExternal;
}(react_1.default.Component));
exports.default = FacebookExternal;
//# sourceMappingURL=facebook.js.map